function getWindowObject() {
  if (typeof window === "undefined") {
    return null;
  }

  return window;
}

export function registerParticipantLayoutDebugApi(api) {
  const targetWindow = getWindowObject();

  if (!targetWindow) {
    return () => {};
  }

  targetWindow.__participantLayout = api;

  return () => {
    if (targetWindow.__participantLayout === api) {
      delete targetWindow.__participantLayout;
    }
  };
}
